import { Icon } from "src/components/layout/nav/icons/decision-engine";
import { UseSectionHook } from "./types";
import { useFlags } from "launchdarkly-react-client-sdk";
import { NavSection } from "src/components/layout/nav/nav-section";
import { ActiveSectionProps } from "src/components/layout/nav/utils";
import { useUser } from "src/contexts/user-context";
import { NavItem } from "src/components/layout/nav/nav-item";
import { isPresent } from "ts-extras";
import { useIsAiDecisionEngineEnabled } from "src/pages/decision-engines/utils";
import { useSpaceContext } from "src/components/spaces";

export const useDecisionEnginesSection: UseSectionHook = () => {
  const { aidGenerateTags } = useFlags();
  const { resources, user } = useUser();
  const decisionEngineEnabled = useIsAiDecisionEngineEnabled();

  if (!resources?.decisionEngine) {
    return {
      title: "AI Decisioning",
      isEnabled: decisionEngineEnabled,
      links: [
        {
          href: "/ai",
          label: "AI Decisioning",
        },
      ],
    };
  }

  return {
    title: "AI Decisioning",
    isEnabled: decisionEngineEnabled,
    links: [
      {
        isSub: true,
        href: "/ai/flows",
        label: "Agents",
      },
      aidGenerateTags && {
        isSub: true,
        href: "/ai/tags",
        label: "Tags",
      },
      {
        isSub: true,
        href: "/ai/insights",
        label: "Insights",
      },
      {
        isSub: true,
        href: "/ai/inspector",
        label: "Inspector",
      },
      {
        isSub: true,
        href: "/ai/configuration",
        label: "Configuration",
      },
      user?.can_impersonate &&
        user?.is_impersonating && {
          isSub: true,
          href: "/ai/admin",
          label: "Admin",
        },
    ].filter(isPresent),
  };
};

export const DecisionEngines = (props: ActiveSectionProps) => {
  const section = useDecisionEnginesSection();
  const { resources } = useUser();
  const decisionEngineEnabled = useIsAiDecisionEngineEnabled();
  const { isInSpace } = useSpaceContext();

  // Hide when in a space - /ai routes are legacy routes wrapped in SpaceAccessGuard
  // with "hidden-from-limited-view", but they're not in the route registry
  if (isInSpace) {
    return null;
  }

  if (resources?.decisionEngine && decisionEngineEnabled) {
    return <NavSection icon={Icon} {...section} {...props} />;
  }

  return <NavItem href="/ai" icon={Icon} label="AI Decisioning" />;
};
